import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/football', label: '分类' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className={`ri-live-line text-2xl ${scrolled ? 'text-primary-500' : 'text-white'}`}></i>
          </div>
          <span
            className={`text-lg font-heading font-semibold tracking-wide whitespace-nowrap ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            每日大赛
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                  ? scrolled
                    ? 'text-primary-500'
                    : 'text-white font-semibold'
                  : scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/85 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/category/football"
            className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-1"></i>观看直播
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-md ${
            scrolled ? 'text-foreground-800' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 px-3 rounded-md transition-colors cursor-pointer ${
                  location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/football"
              className="mt-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-1"></i>观看直播
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}